class ImageUploader {
  async upload(file) {
    const data = new FormData();
    data.append("file", file);
    data.append(
      "upload_preset",
      process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET
    );

    const response = await fetch(
      "https://api.cloudinary.com/v1_1/dojstew3z/image/upload",
      {
        method: "POST",
        body: data,
      }
    );
    return await response.json();
  }
}

export default ImageUploader;
